import React, { Component } from "react";

export default class Dot extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			x: 0,
			y: 0
		};
	}

	logMousePosition = e => {
		this.setState({
			x: e.clientX,
			y: e.clientY
		});
	};
	componentDidMount() {
    	window.addEventListener("mousemove", this.logMousePosition);
    }
	render() {
		return (
			<div className="c-dot" style={{ left: this.state.x + 'px', top: this.state.y + 'px' }}></div>
		);
  	}
}